import React, { useState, useEffect } from "react";
import { Transition } from "react-transition-group";
import cx from "clsx";

import styles from "./text.module.scss";

const TextFromLeft = props => {
  const {
    delayMs = 0,
    durationMs = 720,
    visible: _visible,
    children,
    className
  } = props;

  const [visible, setVisible] = useState(false);
  const memoSetVisible = val => () => setVisible(val);

  useEffect(() => {
    if (!visible && _visible) setTimeout(memoSetVisible(true), 1);
    //
  }, [_visible]); // eslint-disable-line

  return (
    <Transition in={visible} delay={delayMs} timeout={delayMs + durationMs}>
      {state => (
        <div
          className={cx(
            styles.container,
            styles.fromLeft,
            styles[state],
            className
          )}
          style={{
            transitionDelay: `${delayMs}ms`,
            transitionDuration: `${durationMs}ms, ${Math.round(
              durationMs / 2
            )}ms`
          }}
        >
          {children}
        </div>
      )}
    </Transition>
  );
};

export default TextFromLeft;
